import { ErrorHandler, inject, Injectable } from '@angular/core';
import { AppLoggingService } from '../services/app-logging.service';

@Injectable()
export class ErrorHandlerInterceptor extends ErrorHandler {
  private readonly _appLoggingService = inject(AppLoggingService);

  override handleError(error: any): void {
    this._appLoggingService.logError(error);
  }
}
